import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProductsAndPagesCourseIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M15.75 0c.414 0 .75.336.75.75s-.336.75-.75.75H2.25c-.414 0-.75.336-.75.75v19.5c0 .414.336.75.75.75H13.5v-6.75c.001-1.242 1.008-2.249 2.25-2.25h6.75v-3c0-.414.336-.75.75-.75s.75.336.75.75v3.129c0 .317-.066.626-.197.919l-.006.013c-.111.245-.265.468-.455.659l-8.123 8.121c-.199.199-.433.358-.691.47-.283.126-.59.19-.899.189H2.25C1.008 23.999.001 22.992 0 21.75V2.25C.001 1.008 1.008.001 2.25 0h13.5zm5.69 15h-5.69c-.414 0-.75.336-.75.75v5.689L21.44 15zM10.5 15c.414 0 .75.336.75.75s-.336.75-.75.75h-6c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6zm2.25-4.5c.414 0 .75.336.75.75s-.336.75-.75.75H4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.25zM20.25 0c1.241 0 2.25 1.009 2.25 2.25v6c0 .414-.336.75-.75.75S21 8.664 21 8.25V6h-1.5v2.25c0 .414-.336.75-.75.75S18 8.664 18 8.25v-6C18 1.009 19.009 0 20.25 0zm-7.5 6c.414 0 .75.336.75.75s-.336.75-.75.75H7.5c-.414 0-.75-.336-.75-.75S7.086 6 7.5 6h5.25zm7.5-4.5c-.414 0-.75.336-.75.75V4.5H21V2.25c0-.414-.336-.75-.75-.75z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ProductsAndPagesCourseIcon = __decorateClass([
  customElement("elm-products-and-pages-course-icon")
], ProductsAndPagesCourseIcon);
export { ProductsAndPagesCourseIcon };
